import SEO from "@/components/SEO";
export default function HumanRightsPage() {
  return (
    <div className="min-h-screen bg-white text-black px-6 md:px-20 pt-32 pb-12">
      <SEO
        title="Human Rights Policy | VANCO"
        description="VANCO's commitment to respecting human rights, fair labor practices and an inclusive workplace."
        path="/human-rights"
      />
      <div className="max-w-7xl mx-auto">
        <h1 className="text-3xl font-semibold mb-8">VANCO - Human Rights Statement</h1>

        <p className="mb-4 font-light">
          At VANCO, we are committed to upholding and promoting human rights across our company and its subsidiaries. We recognize and respect the fundamental rights of all
          individuals, as enshrined in international human rights principles, including the Universal Declaration of Human Rights (UDHR) and the United Nations Guiding Principles
          on Business and Human Rights (UNGPs).
        </p>

        <h3 className="text-xl font-normal mb-4">Scope & applicability:</h3>

        <p className="mb-4 font-light">
          This Human Rights Statement applies to all employees of VANCO and its subsidiaries. Its benefits also extend to third parties associated with the company, including
          contractors, consultants, trainees, interns, and visitors.
        </p>

        <h3 className="text-xl font-normal mb-4">Our Commitment to Human Rights</h3>

        <p className="mb-4 font-light">
          We are dedicated to ensuring that human rights are upheld in letter and spirit throughout our organization. Our commitment includes:
        </p>

        <ul className="list-disc pl-6 mb-6 space-y-2 font-light">
          <li>
            <strong>Right to Life and Liberty</strong> - We respect and protect the dignity, safety, and well-being of all individuals associated with our business.
          </li>
          <li>
            <strong>Freedom from Slavery and Forced Labor</strong> - We have a zero-tolerance approach for any form of forced labor, human trafficking, or child labor within
            our company and subsidiaries.
          </li>
          <li>
            <strong>Freedom from Discrimination and Harassment</strong> - We promote a safe, inclusive, and respectful workplace, free from discrimination based on race, gender,
            nationality, religion, disability, or any other status.
          </li>
          <li>
            <strong>Freedom of Opinion and Expression</strong> - We uphold the right to free speech and open communication, fostering a culture of respect and inclusivity.
          </li>
          <li>
            <strong>Right to Education and Skill Development</strong> - We encourage learning, training, and professional growth for our employees.
          </li>
        </ul>

        <p className="font-light">
          VANCO upholds human rights and supports community development through its Code of Conduct, Whistleblower Policy and Vigil Mechanism and Supplier Code of Conduct.
          These principles guide our approach to fostering a fair and inclusive environment.
        </p>
      </div>
    </div>
  );
}
